import { MenuItem, Select, SelectProps } from '@material-ui/core'
import React from 'react'

export type UnitSelectorProps = {
  selectableAbbreviations: string[]
} & SelectProps

export function UnitSelector(props: UnitSelectorProps) {
  const { selectableAbbreviations, ...selectProps } = props

  if (!selectableAbbreviations?.length) {
    if (props.value) {
      return <span>{props.value}</span>
    } else {
      return null
    }
  }

  return (
    <Select {...selectProps}>
      {selectableAbbreviations.map((unit) => {
        return (
          <MenuItem value={unit} key={unit}>
            {unit}
          </MenuItem>
        )
      })}
    </Select>
  )
}
